import React from 'react';
import {Link, withRouter} from 'react-router-dom';
import {connect} from "react-redux";

import {
    CardContainer,
    Notification,
    ActionSheet,
    ListItem,
    Player,
    Loading,
    ConfirmDialog,
    Image,
    IconButton
} from 'components/common/uiKit';
import {NoRecord} from 'components/common/app';

import * as RouteService from 'services/route'
import {serverUrl, apiUrl} from 'services/network';
import {LevelApi} from 'services/network/api';

class Level extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            levelId: 0,
            data: undefined,
            text: '',
            actionSheetShow: false,
            loading: true,
            showConfirmDialog: false,
            agreeBtnLoading: false,
            isPending: false,
            passed: false,
            sendLoading: false,
            selectedItemId: 0
        };
    }

    componentDidMount() {
        this.getQsData();
    }

    getQsData() {
        const qs = RouteService.QueryStringService.getQyeryStrings();

        if (!qs || !qs.id) {
            Notification('error', 'WrongParams');

            const {history} = this.props;
            history.goBack();
        }

        this.setState({levelId: qs.id}, () => {
            this.loadData()
        });
    }

    loadData() {
        const {levelId} = this.state;

        if (levelId) {
            //TODO: Use loading
            LevelApi.GetCmsAdminDetails(levelId)
                .then(res => {
                    if (res && res.status == 200) {
                        const {data} = res;
                        this.setState({data: data.details, title: data.title});
                    }
                }).finally(() => {
                this.setState({loading: false});
            })
        }
    }

    _handleBubbles = (item) => {
        let {contentType, content, userType} = item;
        const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent)

        const {locale} = this.props;
        const pageTranslates = locale.translation.Notifications;

        if (userType == 0 || userType == 1) {
            const userTypeClass = item.userType == 0 ? 'speech-left bg-highlight' : 'speech-right color-black';

            switch (contentType) {
                case 1:
                    content = item.content.split("\\n").map((text, i) => i ? [<br/>, text] : text);
                    return (
                        <>
                            <div className="clearfix"></div>
                            <IconButton icon='times' iconStyle={{fontSize: 10, color: 'darkred'}}
                                        onClick={this.handleDeleteConfirm(item.id)}/>
                            <div className={`speech-bubble ${userTypeClass}`}>
                                {content}
                            </div>
                        </>
                    );
                case 2:
                    const image = serverUrl + content;
                    return (
                        <>
                            <div className="clearfix"></div>
                            <IconButton icon='times' iconStyle={{fontSize: 10, color: 'darkred'}}
                                        onClick={this.handleDeleteConfirm(item.id)}/>
                            <div className={`speech-bubble speach-image ${userTypeClass}`}>
                                <Image src={image} style={{width: '100%', height: '100%', borderRadius: 20}}
                                       className="img-fluid preload-img"/>
                            </div>
                        </>
                    );
                case 3:
                    const url = `${apiUrl}/Media/Get?address=${content}`;

                    return (
                        <>
                            <div className="clearfix"></div>
                            <IconButton icon='times' iconStyle={{fontSize: 10, color: 'darkred'}}
                                        onClick={this.handleDeleteConfirm(item.id)}/>
                            <div className={`speech-bubble speach-image ${userTypeClass}`}>
                                <Player url={url}/>
                            </div>
                        </>
                    );
            }
        } else if (userType == 2) {
            if (contentType == 1)
                return (
                    <>
                        <div className="clearfix"></div>
                        <p className="text-center mb-0 font-11">{pageTranslates[content]}</p>
                    </>
                );
        }
    };

    _handleChangeText = (evt) => {
        this.setState({text: evt.target.value});
    };

    _handleTextSend = () => {
        const {text, levelId, sendLoading} = this.state;
        if (text && levelId && !sendLoading) {
            const model = {text, levelId: parseInt(levelId)};
            LevelApi.AdminCmsText(model)
                .then(res => {
                    if (res && res.status == 200) {
                        this.loadData();
                        this.setState({text: ''});
                    }
                }).finally(x => {
                this.setState({sendLoading: false});
            });
        }
    };

    actionSheetCallback = (state) => {
        this.setState({actionSheetShow: state});
    };

    _handleImageUpload = (evt) => {
        const {levelId} = this.state;
        const file = evt.target.files;
        if (file && levelId) {
            this.setState({loading: true});

            let formData = new FormData();
            formData.append("LevelId", levelId);
            formData.append("ContentType", 2);
            formData.append("File", file[0]);

            //TODO: use loading or uploadProgress
            LevelApi.AdminCmsUpload(formData)
                .then(res => {
                    if (res && res.status) {
                        this.loadData();
                    }
                }).finally(() => {
                this.setState({actionSheetShow: false, loading: false});
            });
        }
    };

    _handleFilmUpload = (evt) => {
        const {levelId} = this.state;
        const file = evt.target.files;
        if (file && levelId) {
            this.setState({loading: true});

            let formData = new FormData();
            formData.append("LevelId", levelId);
            formData.append("ContentType", 3);
            formData.append("File", file[0]);

            //TODO: use loading or uploadProgress
            LevelApi.AdminCmsUpload(formData)
                .then(res => {
                    if (res && res.status) {
                        this.loadData();
                    }
                }).finally(() => {
                this.setState({actionSheetShow: false, loading: false});
            });
        }
    };

    ref = player => {
        this.player = player
    };

    _handleFooter = () => {
        const {text, isPending, passed} = this.state;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Level.Detail.Footer;

        if (passed || isPending) {
            const message = passed ? pageTranslates.Done : pageTranslates.Pending;
            return (
                <>
                    <div className="flex-fill speach-input">
                        <h6 className='text-center color-primary mt-3' style={{whiteSpace: 'pre-line'}}>
                            {message}
                        </h6>
                    </div>
                </>
            );
        }

        return (
            <>
                <div className="mr-3 speach-icon">
                    <a className="bg-gray2-dark ml-2 speach-icon-link"
                       onClick={() => this.setState({actionSheetShow: true})}><i
                        className="fa fa-plus"></i></a>
                </div>
                <div className="flex-fill speach-input mr-2">
                    <input type="text" className="form-control" onChange={this._handleChangeText}
                           value={text}
                           placeholder={pageTranslates.PlaceHolder}/>
                </div>
                <div className="ml-2 speach-icon">
                    <a className="bg-blue2-dark mr-2 speach-icon-link" onClick={this._handleTextSend}>
                        <i className="fa fa-arrow-up"></i></a>
                </div>
            </>
        );
    };

    handleDeleteConfirm = id => () => {
        this.setState({showConfirmDialog: true, selectedItemId: id});
    };

    handleSubmitDelete = () => {
        const {selectedItemId} = this.state;
        if (selectedItemId) {
            this.setState({agreeBtnLoading: true});

            const model = {id: parseInt(selectedItemId)};
            LevelApi.AdminCmsDelete(model)
                .then(res => {
                    this.setState({selectedItemId: 0, showConfirmDialog: false})
                    this.loadData();
                }).finally(() => {
                this.setState({agreeBtnLoading: false});
            });
        }
    };

    handleCancelDelete = () => {
        this.setState({showConfirmDialog: false, selectedItemId: 0});
    };

    handleSettingOnClick = () => {
        const {levelId} = this.state;
        if (levelId) {
            const {history} = this.props;
            history.push({
                pathname: `levelSetting?id=${levelId}`
            })
        }
    };

    render() {
        const {title, data, text, actionSheetShow, loading, showConfirmDialog, agreeBtnLoading, isPending} = this.state;

        if (loading)
            return <Loading/>;

        const {locale} = this.props;
        const pageTranslates = locale.translation.Pages.Admin.CMS.Level.Detail;

        return (
            <>

                    <CardContainer>
                        <div className='pb-2 d-flex align-items-center'>

                            <IconButton icon='cog' iconStyle={{fontSize: 13}} onClick={this.handleSettingOnClick}/>
                            <h3 className='color-primary mb-0'>
                                {title}
                            </h3>
                        </div>

                        {!data || data.length == 0 ?
                            <NoRecord message='Level'/>
                            :
                            <div>
                                {data.map(item => {
                                    return this._handleBubbles(item);
                                })}
                            </div>
                        }
                    </CardContainer>


                <div id="footer-bar" className="d-flex footer-bar-action safe-area-view-bottom"
                     style={{zIndex: 99}}>
                    {this._handleFooter()}
                </div>

                <ActionSheet show={actionSheetShow} callback={this.actionSheetCallback} hasClose>
                    <h5 className='text-center'>
                        {pageTranslates.UploadContent}
                    </h5>

                    <div className="list-group list-custom-small">
                        <a className='list-item-style' onClick={() => {
                            global.document.getElementById('browseImageFileButton').click();
                        }}>
                            <div className='selectFileButton' className='float-right d-flex align-items-center'>
                                <i className='rounded-sm shadow-xl bg-primary'
                                   style={{fontStyle: 'normal', marginTop: 0}}>
                                    <p className={`fa fa-image`} style={{fontSize: 13, color: 'black'}}></p>
                                </i>
                                <input
                                    id="browseImageFileButton"
                                    type="file"
                                    accept="image/*"
                                    onChange={this._handleImageUpload}
                                    hidden
                                />
                                <span>
                                    {pageTranslates.ContentTypes.Image}
                                </span>
                            </div>
                            <i className="fa fa-angle-left"></i>
                        </a>
                        <a className='list-item-style' onClick={() => {
                            global.document.getElementById('browseFilmFileButton').click();
                        }}>
                            <div className='selectFileButton' className='float-right d-flex align-items-center'>
                                <i className='rounded-sm shadow-xl bg-primary'
                                   style={{fontStyle: 'normal', marginTop: 0}}>
                                    <p className={`fa fa-film`} style={{fontSize: 13, color: 'black'}}></p>
                                </i>
                                <input
                                    id="browseFilmFileButton"
                                    type="file"
                                    accept="video/mov, video/3g2, video/3gp, video/3gp2, video/3gpp, video/asf, video/asx, video/avi, video/divx, video/m4v,  video/mp4, video/mpe, video/x-m4v, video/mpeg, video/mpg, video/ogg, video/wmv"
                                    onChange={this._handleFilmUpload}
                                    hidden
                                />
                                <span>
                                    {pageTranslates.ContentTypes.Movie}
                                </span>
                            </div>
                            <i className="fa fa-angle-left"></i>
                        </a>
                    </div>
                </ActionSheet>

                <ConfirmDialog open={showConfirmDialog} title={pageTranslates.DeleteConfirmDialog.Title}
                               content={pageTranslates.DeleteConfirmDialog.Content}
                               onAgree={this.handleSubmitDelete} onCancel={this.handleCancelDelete}
                               agreeLoading={agreeBtnLoading}/>
            </>
        )
    }
}

const mapStateToProps = state => {
    const {locale} = state;
    return {locale};
};

export default connect(mapStateToProps, null)(withRouter(Level));